<template>

<app-content :loading="is.loading">

	<app-content-body v-if="!is.loading" :is-call="true">

		<app-content-call :loading="is.confirming" icon="approve" theme="green" title="Accept Application" :text="(hasBadges) ? 'The application will be accepted and the user will receive an email notification including a link to complete their badge purchase. You can also optionally include feedback and select which badge types they can purchase.' : 'The application will be accepted and the user will receive an email notification including a link to complete their badge purchase. You can also optionally include feedback.'" :disabled="!model.badges.length" :has-cancel="true" button="Confirm" v-on:click="onConfirmClick" v-on:cancel="onCancelClick">

            <app-input-checklist v-if="hasBadges" v-model="model.badges" :columns="1" :options="$util.options(badges)" class="badges" />

			<div class="suggestion" v-for="suggestion in suggestions" :key="suggestion.id">

				<div class="suggestion-item is-name"><small>Approved Suggestion</small>{{ suggestion.name }}</div>
				<div class="suggestion-item"><small>Day</small>{{ $con.schedule.days[suggestion.day] }}</div>
				<div class="suggestion-item"><small>Starts</small>{{ $con.schedule.times[suggestion.time] }}</div>
				<div class="suggestion-item"><small>Ends</small>{{ $con.schedule.times[suggestion.time + suggestion.duration] }}</div>

			</div>

            <app-input-text :autogrow="true" v-model="model.feedback" placeholder="(optional) Enter your feedback..." class="feedback" />

		</app-content-call>
	
	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {

		return {
			is: {
				loading: true,
				confirming: false
			},
            model: {
                feedback: '',
                badges: []
            },
			event: {},
            badges: [],
			suggestions: []
		}

	},

	created: function() {

		this.load();

	},

    computed: {
    
        hasBadges: function() {
        
            return this.$_.keys(this.badges).length > 1
        
        }

    },

	methods: {

		onCancelClick: function() {

			this.$router.push({
				name: 'Convention.Registration.Applications.Edit'
			})

		},

		onConfirmClick: async function() {

			this.is.confirming = true

			this.$api.post('convention/registration/application/' + this.$route.params.id + '/accept', this.model).then(function() {

				this.$notify({
					message: 'Your feedback has been sent!'
				})

				this.$router.push({
                    name: 'Convention.Registration.Applications.Edit'
				})

            }.bind(this))

		},

		load: function() {

			this.$api.get('convention/registration/application/' + this.$route.params.id + '/accept').then(function(response) {

				Vue.set(this, 'event', response.event)
				Vue.set(this, 'badges', response.badges)
				Vue.set(this, 'suggestions', response.suggestions)

                this.model.badges = this.$_.keys(response.badges)

				this.is.loading = false

			}.bind(this), function() {
            
                this.$notify({
					message: 'This is not a pending application.',
					type: 'error'
				})

				this.$router.push({
                    name: 'Convention.Registration.Applications.Edit'
				})
            
            }.bind(this))

		}

	}

}

</script>

<style scoped>

.feedback {
    width: 100%;
    margin-top: 20px;
}

.badges {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 0px;
}

.suggestion {
	display: flex;
	margin-top: 20px;
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 10px;
	width: 100%;
}

.suggestion-item {
	padding: 10px 10px;
	flex-shrink: 0;
	font-weight: 400;
	font-size: 16px;
}

.suggestion-item.is-name {
	flex-grow: 1;
}

.suggestion-item small {
	display: block;
	font-weight: 300;
	font-size: 12px;
	color: #666;
	margin-bottom: 2px;
}

.suggestion.is-empty {
	padding: 20px;
    align-items: center;
    justify-content: center;
    margin: 0px;
    background-color: #dd4848;
    border: 0px;
    color: #fff;
    font-weight: 400;
}

</style>
